/**
 * Logo wordmark for Island Gold Glow Soap Co.
 * Visual element: "I [leaf] G" — a stylised monogram with a palm leaf.
 */
export default function Logo({ size = "md", variant = "light" }) {
    const fontSize =
        size === "sm" ? "text-lg" : size === "lg" ? "text-4xl" : "text-2xl";
    const color = variant === "light" ? "#1A432B" : "#F5E8C8";
    const gold = "#D4A04B";
    const leafSize = size === "sm" ? 16 : size === "lg" ? 28 : 22;

    return (
        <span
            className="inline-flex items-center gap-1.5 font-serif leading-none select-none"
            style={{ color }}
            aria-label="Island Gold Glow Soap Co."
        >
            <span className={`${fontSize} tracking-tight`}>I</span>
            <svg
                width={leafSize}
                height={leafSize}
                viewBox="0 0 32 32"
                fill="none"
                aria-hidden="true"
            >
                {/* Stylised palm leaf */}
                <path
                    d="M16 3 C 10 8, 6 14, 6 22 C 10 20, 13 18, 16 14 C 19 18, 22 20, 26 22 C 26 14, 22 8, 16 3 Z"
                    fill={gold}
                />
                <path
                    d="M16 14 L 16 29"
                    stroke={color}
                    strokeWidth="1.4"
                    strokeLinecap="round"
                />
                <path
                    d="M16 18 L 11 16 M16 21 L 10 20 M16 24 L 11 24"
                    stroke={color}
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    opacity="0.55"
                />
                <path
                    d="M16 18 L 21 16 M16 21 L 22 20 M16 24 L 21 24"
                    stroke={color}
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    opacity="0.55"
                />
            </svg>
            <span className={`${fontSize} tracking-tight italic`} style={{ color: gold }}>
                G
            </span>
        </span>
    );
}
